import React from 'react';
import { CFooter } from '@coreui/react';

const TheFooter = () => {
  return (
    <CFooter fixed={false}>
      <div className="mfs-auto">&copy; 2021 SHIZEN ENERGY Inc. All Rights Reserved.</div>
    </CFooter>
  );
};

export default React.memo(TheFooter);
